import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {scraperRegister} from "../../services/scraperRegister";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";

class SignupQuotesDivided extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            quotes: [],
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            page: 1,
            page_load: 5,
            admin: false,
            customQuote: {
                selected: false,
                saved: false,
                text: "",
                modal: false,
                custom: true
            },
            customCount: 0,
            error: false,
            sale: "instant",
            step: "activation",
            steps: {
                activation: {title: {sv: "en slogan som väcker intresse", en: "a slogan that creates interest"}, value: "activation", next: "validation", previous: null, step: 1, selected: null},
                validation: {title: {sv: "en slogan som bekräftar din verksamhet", en: "a slogan that validates your business"}, value: "validation", next: "offer", previous: "activation", step: 2, selected: null},
                offer: {title: {sv: "en slogan som skapar mervärde", en: "a slogan that adds value"}, value: "offer", next: "action", previous: "validation", step: 3, selected: null},
                action: {title: {sv: "en slogan som uppmanar till handling", en: "a slogan that calls for action"}, value: "action", next: null, previous: "offer", step: 4, selected: null}
            }
        };
        this._renderAdminQuote = this._renderAdminQuote.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();

        if(window.innerWidth > 1050){
            this.setState({page_load: 10}, () => {
                this._updateData();
            });
        }else{
            this.setState({page_load: 8}, () => {
                this._updateData();
            });
        }

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/quotes');
            ReactGA4.send({ hitType: "pageview", page: "/signup/quotes" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        //CHECK VIEW
        let view = quotesRegister.getView();
        if(view === "custom"){
            cartRegister.setQuotes(null);
        }
        quotesRegister.setView(null);

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    admin: user.reseller || user.inhouse,
                    inhouse: user.inhouse
                });
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();

            //SET SALE TYPE
            this.setState({sale:stored_data.crossroad});

            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
                }
            }
            if (stored_data.industry && (stored_data.image || stored_data.admin_image)) {
                this.setState({
                    industry: stored_data.industry
                }, () => {
                    this._updateQuotes(this.state.industry.id, salesChannelRegister.get('market'), langRegister.lang());
                });
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuotes(industry, market, lang) {
        try {
            let stored_quotes = quotesRegister.get();
            let stored_page = quotesRegister.page();
            if (stored_quotes) {
                this.setState({
                    quotes: stored_quotes,
                    page: stored_page,
                    isLoading: false
                }, () => {
                    this._updateQuote();
                });
            } else {
                dataRegister.quotes(industry, market, lang).then((data) => {
                    if (data.errors) {
                        this.setState({
                            isLoading: false
                        });
                    } else {
                        let quotes = data;

                        //REMOVE INDUSTRY SLOGANS
                        let industry_slogans = [];
                        let other_quotes = [];
                        for(let i = 0; i < quotes.length; i++){
                            if(quotes[i].slogan.indexOf(this.state.industry.name) !== -1){
                                industry_slogans.push(quotes[i]);
                            }else{
                                other_quotes.push(quotes[i]);
                            }
                        }

                        other_quotes.sort(function(a, b) {
                            var textA = a.slogan.toUpperCase();
                            var textB = b.slogan.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });

                        /*
                        //ADD SCRAPED SLOGANS
                        let scraped_data = JSON.parse(scraperRegister.get());
                        let scraped_data_length = 0;
                        try{
                            scraped_data_length = scraped_data.slogans.length;
                            for(let i = 0; i < scraped_data.slogans.length; i++){
                                industry_slogans.unshift({
                                    slogan: scraped_data.slogans[i],
                                    id: "scraped_" + i,
                                    custom: true,
                                    scraped: true,
                                    sale: "both",
                                    type: "both",
                                    index: 0
                                });
                            }
                        }catch (e) {}
                        */

                        industry_slogans = industry_slogans.concat(other_quotes);

                        this.setState({
                            quotes: industry_slogans,
                            customCount: this.state.customCount, //+ scraped_data_length,
                            isLoading: false
                        }, () => {
                            quotesRegister.set(this.state.quotes, 1, lang);
                            this._updateQuote();
                        });
                    }

                }, (error) => {
                    this.setState({error: true});
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuote() {
        try {
            let stored_quotes = cartRegister.get();
            if (stored_quotes.quotes) {

                for(let key in stored_quotes.quotes){
                    if(stored_quotes.quotes[key].index === 0){
                        this.state.steps.activation.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 1){
                        this.state.steps.validation.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 2){
                        this.state.steps.offer.selected = stored_quotes.quotes[key];
                    }
                    if(stored_quotes.quotes[key].index === 3){
                        this.state.steps.action.selected = stored_quotes.quotes[key];
                    }
                }

                this.setState({steps: this.state.steps});


                /*
                this.setState({
                    selected: stored_quotes.quotes
                }, () => {
                    //FILTER BY SELECTED QUOTES
                    let quotes = [];
                    let selected = [];
                    let scraped_count = 0;
                    for(let i = 0; i < this.state.quotes.length; i++){
                        if(this.state.selected[this.state.quotes[i].id]){
                            selected.push(this.state.quotes[i]);
                        }else{
                            quotes.push(this.state.quotes[i]);
                        }
                    }
                    selected.sort(function(a, b) {
                        return a.index - b.index;
                    });

                    if(selected.length > 3){
                        this.state.step = "action";
                    }else{
                        this.state.step = "activation";
                    }

                    selected = selected.concat(quotes);
                    this.setState({
                        quotes: selected,
                        step: this.state.step
                    });
                });
                */
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectQuote(prop) {
        try {
            if (!this.state.isLoading && !this.state.isSelecting) {

                let exist = false;
                try {
                    if(this.state.steps[this.state.step].selected.id === prop.id){
                        this.state.steps[this.state.step].selected = null;
                        exist = true;
                    }
                }catch (e) {}

                if(!exist){
                    this.setState({isSelecting: true}, () => {
                        this.state.steps[this.state.step].selected = prop;
                        if(this.state.steps[this.state.step].next){
                            this.setState({
                                steps: this.state.steps,
                            }, () => {
                                setTimeout(() => {
                                    window.scrollTo(0, 0);
                                    this.setState({
                                        step: this.state.steps[this.state.step].next,
                                        isSelecting: false
                                    })
                                }, 200);
                            })
                        }else{
                            this.setState({
                                steps: this.state.steps,
                            }, () => {
                                setTimeout(() => {
                                    try {
                                        let selected = {};

                                        selected[this.state.steps.activation.selected.id] = JSON.parse(JSON.stringify(this.state.steps.activation.selected));
                                        selected[this.state.steps.activation.selected.id].index = 0;
                                        selected[this.state.steps.activation.selected.id].selected = true;

                                        selected[this.state.steps.validation.selected.id] = JSON.parse(JSON.stringify(this.state.steps.validation.selected));
                                        selected[this.state.steps.validation.selected.id].index = 1;
                                        selected[this.state.steps.validation.selected.id].selected = true;

                                        selected[this.state.steps.offer.selected.id] = JSON.parse(JSON.stringify(this.state.steps.offer.selected));
                                        selected[this.state.steps.offer.selected.id].index = 2;
                                        selected[this.state.steps.offer.selected.id].selected = true;

                                        selected[this.state.steps.action.selected.id] = JSON.parse(JSON.stringify(this.state.steps.action.selected));
                                        selected[this.state.steps.action.selected.id].index = 3;
                                        selected[this.state.steps.action.selected.id].selected = true;

                                        videoRegister.remove();
                                        carouselRegister.remove();
                                        cartRegister.setQuotes(selected);
                                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
                                    }catch (e) {}
                                }, 200);
                            });
                        }
                    });
                }else{
                    this.setState({
                        steps: this.state.steps
                    })
                }


                /*
                if (this.state.customQuote.selected) {
                    this.state.customQuote.selected = false;
                    this.setState({
                        customQuote: this.state.customQuote
                    });
                }
                if (this.state.selected[prop.id]) {
                    delete this.state.selected[prop.id];
                    prop.selected = false;
                    this.setState({
                        selected: this.state.selected,
                        quotes: this.state.quotes
                    }, () => {
                        videoRegister.remove();
                        carouselRegister.remove();
                        cartRegister.setQuotes(this.state.selected);
                    });

                } else {
                    if (Object.keys(this.state.selected).length > 3) {
                        videoRegister.remove();
                        carouselRegister.remove();
                        cartRegister.setQuotes(this.state.selected);
                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
                    } else {
                        prop.selected = true;
                        this.state.selected[prop.id] = prop;
                        let index = 0;
                        for(let key in this.state.selected){
                            if(this.state.selected[key].index && this.state.selected[key].index > index){
                                index = this.state.selected[key].index;
                            }
                        }
                        index++;
                        this.state.selected[prop.id].index = index;
                        this.setState({
                            selected: this.state.selected,
                            quotes: this.state.quotes
                        }, () => {
                            try {
                                if(this.state.steps[this.state.step].next){
                                    window.scrollTo(0, 0);
                                    this.setState({step: this.state.steps[this.state.step].next});
                                }else{
                                    videoRegister.remove();
                                    carouselRegister.remove();
                                    cartRegister.setQuotes(this.state.selected);
                                    if (Object.keys(this.state.selected).length > 3) {
                                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
                                    }
                                }
                            }catch (e) {}
                        });
                    }
                }
                */
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectCustomQuote() {
        try {
            if (!this.state.isLoading) {
                this.state.customQuote.selected = true;
                this.setState({
                    customQuote: this.state.customQuote,
                    selected: {}
                });
                cartRegister.setAdAdminQuotes(this.state.customQuote);
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _setCustomQuote(){

        try {
            let words = this.state.customQuote.text.split(" ");
            for(let i = 0; i < words.length; i++){
                words[i] = capitalizeFLetter(words[i]);
            }
            this.state.customQuote.text = words.join(" ");
        }catch (e) {
            console.log(e);
        }

        this.state.quotes.unshift({
            slogan: this.state.customQuote.text,
            id: "custom_" + this.state.quotes.length + 1,
            custom: true,
            sale: "both",
            type: "both",
            index: 0
        });

        this.setState({quotes: this.state.quotes, customCount: this.state.customCount + 1}, () => {
            console.log(this.state.quotes);
        });

        function capitalizeFLetter(string) {
            return  string.charAt(0).toUpperCase() + string.slice(1);
        }

    }

    _addCustomQuote() {
        try {
            this.state.customQuote.modal = true;
            this.state.customQuote.text = "";
            this.setState({
                customQuote: this.state.customQuote
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _moreQuotes() {
        try {
            this.setState({page_load: window.innerWidth > 1050?5:4}, () => {
                this.setState({
                    page: this.state.page + (this.state.page === 1?2:1)
                }, () => {
                    console.log(this.state.page);
                    this._scrollTo("bottom");
                    quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                });
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _back(){
        if(!this.state.steps[this.state.step].previous){
            if(this.state.inhouse){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/slideshow")
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image")
            }
        }else{
            window.scrollTo(0, 0);
            this.setState({step: this.state.steps[this.state.step].previous});
        }
    }

    _next(){
        if(Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved){
            if(this.state.customQuote.saved && this.state.customQuote.selected){
                cartRegister.setAdAdminQuotes(this.state.customQuote);
            }
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderStep(){
        try {
            return this.state.steps[this.state.step].step;
        }catch (e) {}
    }

    _renderStepTitle(){
        try {
            return this.state.steps[this.state.step].title[langRegister.lang()];
        }catch (e) {
            console.log(e);
        }
    }

    _renderAdminQuote(e){
        try{
            const re = /^[\x00-\xFF]*$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.state.customQuote.text = e.target.value;
                this.setState({customQuote: this.state.customQuote});
            }
        }catch (e) {
            console.log(e);
        }
    }

    _renderSelected(prop){
        try {
            return this.state.steps[this.state.step].selected.id === prop.id;
        }catch (e) {
            return false;
        }
    }

    _renderQuote(slogan){
        try {
            let string = slogan.replace(this.state.industry.name, '<bold><div>&nbsp;'+this.state.industry.name+'&nbsp;</div></bold>');
            return (<span {...innerHtml(string)}></span>);
        }catch (error) {
            return slogan;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-quotes-divided", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>

                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div className={Styles.title}>
                                {
                                    this.state.customQuote.modal &&
                                    <div>
                                        {this._renderText("item_5")}
                                    </div>
                                    ||
                                    <div>
                                        {this._renderText("item_1")} {this._renderStepTitle()}..
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.quotesContainer}>

                                {
                                    !this.state.customQuote.modal &&
                                    this.state.quotes.filter((item) => {
                                        return (item.sale === this.state.sale || item.sale === "both")
                                    }).filter((item) => {
                                        return (item.type === "both" || (item.type === "service" && +this.state.industry.type === 1) || (item.type === "product" && +this.state.industry.type === 2))
                                    }).filter((item) => {
                                        return (item.detail === this.state.step)
                                    }).map((prop, i) => {
                                        return (
                                            <div key={i}
                                                 onClick={() => this._selectQuote(prop)}
                                                 className={
                                                     cx(Styles.quotesContainerItem,
                                                         {
                                                             [Styles.quotesContainerItemActive]: this._renderSelected(prop),
                                                         })
                                                 }>
                                                <div className={Styles.quotesContainerItemQuote}>
                                                    {this._renderQuote(prop.slogan)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div
                                    onClick={() => this._back()}
                                    className={
                                        cx(Styles.backButton,
                                            {
                                                [Styles.backButtonCenter]: false,
                                            })
                                    }>
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width:"100%"}}/>
            </div>
        );
    }
}

export default SignupQuotesDivided;


// WEBPACK FOOTER //
// ./src/pages/signup-quotes-divided/component.js